import { render, staticRenderFns } from "./Elements.vue?vue&type=template&id=483a54d8&scoped=true&"
import script from "./Elements.vue?vue&type=script&lang=ts&"
export * from "./Elements.vue?vue&type=script&lang=ts&"
import style0 from "./Elements.vue?vue&type=style&index=0&id=483a54d8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "483a54d8",
  null
  
)

export default component.exports